export const VENTURES = [
  "Adani Ports & SEZ", "Adani Power", "Adani Green Energy", "Adani Enterprises",
  "Adani Transmission", "Adani Total Gas", "Adani Wilmar", "Adani Airports", "Adani Group"
];

export const STATES = [
  "Gujarat", "Maharashtra", "Jharkhand", "Chhattisgarh", "Odisha",
  "Tamil Nadu", "Karnataka", "Rajasthan", "Kerala", "Andhra Pradesh",
  "Uttar Pradesh", "Madhya Pradesh", "Telangana", "West Bengal",
];

export const CATEGORIES = [
  "Political & Regulatory", "Environment & Resource Conflicts",
  "Land & Displacement", "Legal & Litigation", "Financial Irregularities",
  "Protests", "Media & Narrative", "Geopolitical"
];

export const SUBCATEGORIES = {
  "Political & Regulatory": ["Preferential Treatment", "Policy shifts", "sanctions", "export controls", "elections", "Policy Bias", "Political Nexus", "Lobbying"],
  "Environment & Resource Conflicts": ["Coal Mining Impact", "ESG ratings", "climate litigation", "investor activism", "Coastal Ecology Damage", "Deforestation", "Industrial Pollution", "Mangrove Loss", "Displacement of locals"],
  "Land & Displacement": ["Forced Acquisition", "Tribal Rights Violation", "Sacred Land Concerns", "FRA Violation", "Inadequate R&R"],
  "Legal & Litigation": ["Defamation Cases", "Court Petitions", "Regulatory Actions", "Stays & Injunctions"],
  "Financial Irregularities": ["Foreign Funding", "Institutional Exposure", "Disclosure Issues", "International Probes", "Short-sellers Reports"],
  "Protests": ["Villager Resistance", "Fisherfolk Protests", "Anti-displacement Movements", "Sit-in / Dharna"],
  "Media & Narrative": ["Investigative Journalism", "Fake incidents", "edited videos", "bot campaigns", "WhatsApp virals", "Press Freedom Issues", "Social Media Narratives", "Gag Orders / Suppression"],
  "Geopolitical": ["Supply Chain & Logistics Disruption"],
};

export const PLATFORMS = ["twitter", "youtube", "instagram", "facebook", "reddit", "linkedin", "news"];
export const SEVERITIES = ["critical", "high", "medium", "low"];

export const STATE_COORDS = {
  "Gujarat": [22.2587, 71.1924],
  "Maharashtra": [19.7507, 75.7139],
  "Jharkhand": [23.6102, 85.2799],
  "Chhattisgarh": [21.2787, 81.8661],
  "Odisha": [20.9517, 85.0985],
  "Orissa": [20.9517, 85.0985], // Alias
  "Tamil Nadu": [11.1271, 78.6569],
  "Karnataka": [15.3173, 75.7139],
  "Rajasthan": [27.0238, 74.2179],
  "Kerala": [10.8505, 76.2711],
  "Andhra Pradesh": [15.9129, 79.74],
  "Uttar Pradesh": [26.8467, 80.9462],
  "Madhya Pradesh": [22.9734, 78.6569],
  "Telangana": [18.1124, 79.0193],
  "West Bengal": [22.9868, 87.855],
  "Global": [20.5937, 78.9629],
  "National": [20.5937, 78.9629],
  "India": [20.5937, 78.9629],
  "Global Intelligence": [20.5937, 78.9629],
  "National Strategic Oversight": [20.5937, 78.9629],
  "Andaman & Nicobar": [11.7401, 92.6586],
  "Corporate HQ": [23.0225, 72.5714] // Ahmedabad (Strategic HQ)
};

export const META = { VENTURES, STATES, CATEGORIES, SUBCATEGORIES, PLATFORMS, SEVERITIES, STATE_COORDS };
